import React, { useMemo, useState } from 'react';
import TableLayout from '../components/molecules/TableLayout';
import Table from '../components/molecules/Table';
import { BsThreeDotsVertical } from 'react-icons/bs';
import Button from '../components/molecules/Button';
import ModalContainer from '../components/molecules/ModalContainer';
import Select from '../components/molecules/Select';
import CenterModal from '../components/molecules/Modal/CenterModal';
import SuccessModal from '../components/atoms/SuccessModal';
import { MenuItems, MenuMain } from '../components/atoms/AdminTable/AdminTable.style';
import { HiTrash } from 'react-icons/hi2';
import { HiPencil } from 'react-icons/hi2';
import { MenuButton } from '@szhsin/react-menu';
import DeleteModal from '../components/atoms/DeleteModal';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router-dom';
import AddUserModal from '../components/atoms/AddUserModal';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../Context/authContext';
import userService from '../services/userService';
import Toast from '../components/molecules/Toast';
import { format } from 'date-fns';
import { getDateObject } from '../helpers/common';
import { ActionsWrapper } from '../styles/helpers.styles';

const Users = () => {
  const { id } = useParams();
  const [searchQuery, setSearchQuery] = useState({
    page: 1,
    itemsPerPage: 5,
    searchText: '',
    type: 'all',
    filterStatus: '',
    getStoreInfo: true,
    storeId: id || '',
  });
  const navigate = useNavigate();
  const [editDevice, setEditDevice] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalSuccess, setDeleteModalSuccess] = useState(false);
  const [currentData, setCurrentData] = useState(null);
  const [idToDelete, setIdToDelete] = useState(null);

  const { fetch, refetch, hasPermission } = useContextHook(AuthContext, v => ({
    fetch: v.fetch,
    refetch: v.refetch,
    hasPermission: v.hasPermission,
  }));

  const { users_data, users_loading } = userService.GetUsers(searchQuery, fetch);

  const ConfirmDelete = async () => {
    try {
      await userService.deleteUser(idToDelete);
      Toast({
        message: 'User Deleted Successfully',
        type: 'success',
      });
      refetch();
      setDeleteModal(false);
      setDeleteModalSuccess(true);
    } catch (error) {
      Toast({
        type: 'error',
        message: error?.message,
      });
    }
  };

  const handleUserEditModal = data => {
    setEditDevice(true);
    setCurrentData(data);
  };

  const openDeleteModal = _ => {
    setIdToDelete(_?._id);
    setDeleteModal(true);
  };

  const actionBtn = _ =>
    _?.status === 'Active' && (
      <div className="action-btn-dropdown">
        <MenuMain
          menuButton={
            <MenuButton>
              <BsThreeDotsVertical size={20} color="#9D9D9D" />
            </MenuButton>
          }
          transition>
          {hasPermission('user.edit-user') && (
            <MenuItems onClick={() => handleUserEditModal(_)}>
              <HiPencil size={16} /> Edit User
            </MenuItems>
          )}
          {hasPermission('user.delete-user') && (
            <MenuItems onClick={() => openDeleteModal(_)}>
              <HiTrash size={16} /> Deactivate User
            </MenuItems>
          )}
        </MenuMain>
      </div>
    );

  const Status = status => {
    switch (status) {
      case 'Active':
        return <div className="success">Active</div>;
      case 'Deactivated':
        return <div className="danger">Deactivated</div>;
      default:
        return null;
    }
  };

  const { product_rows, totalCount } = useMemo(() => {
    const items = users_data;
    return {
      product_rows: items?.users?.map(data => [
        format(getDateObject(data?.created_at), 'yyyy-MM-dd') || '------------',
        data.first_name + ' ' + data?.last_name || '------------',
        users_data?.storeData?.title || '------------',
        Status(users_data?.storeData?.status) || '------------',
        data?.email || '------------',
        Status(data?.status) || '------------',
        data?.employee_id || '------------',
        data?.type?.charAt(0)?.toUpperCase() + data?.type?.slice(1) || '------------',
        actionBtn(data),
      ]),
      totalCount: items?.length,
    };
  }, [users_data]);

  const FilterOptions = [
    {
      value: '',
      label: 'All',
    },
    {
      value: 'Active',
      label: 'Active',
    },
    {
      value: 'Deactivated',
      label: 'Deactivated',
    },
  ];

  const columnNamess = [
    'Created at',
    'User Name',
    'Store Title',
    'Store Status',
    'Email Address',
    'Status',
    'ID',
    'Type',
    'Action',
  ];
  const [userSuccessModal, setUserSuccessModal] = useState(false);
  const handleUserSuccessModal = () => {
    setUserSuccessModal(true);
  };
  return (
    <ActionsWrapper>
      {/*----------------- Modal Start -----------------*/}

      {/*----------------- Edit Modal Start -----------------*/}

      <CenterModal open={editDevice} setOpen={setEditDevice} width="669" title="Edit User">
        <AddUserModal
          isEdit={currentData}
          onSubmit={() => setEditDevice(false)}
          onClose={() => setEditDevice(false)}
          data={users_data}
        />
      </CenterModal>

      {/*----------------- Edit Modal End -----------------*/}

      {/*----------------- Delete Modal Start -----------------*/}

      <CenterModal open={deleteModal} setOpen={setDeleteModal} width="580">
        <DeleteModal
          btnClick={ConfirmDelete}
          heading="Deactivate User!"
          para="Are you sure you want to deactivate this user? all the data will be lost."
          btnText="Yes, Deactivate"
          id={idToDelete}
        />
      </CenterModal>
      <CenterModal open={deleteModalSuccess} setOpen={setDeleteModalSuccess} width="580">
        <SuccessModal
          heading="User Deactivated Successfully!"
          btnText="Go Back"
          btnClick={() => setDeleteModalSuccess(false)}
        />
      </CenterModal>

      {/*----------------- Delete Modal End -----------------*/}

      {/*----------------- Add Modal Start -----------------*/}

      <CenterModal open={userSuccessModal} setOpen={setUserSuccessModal} width="580" iscloseAble={false}>
        <SuccessModal
          heading="User Created Successfully!"
          btnText="Go Back"
          btnClick={() => setUserSuccessModal(false)}
        />
      </CenterModal>

      {/*----------------- Add Modal End -----------------*/}

      {/*----------------- Modal End -----------------*/}

      <TableLayout
        onChangeFilters={filters => {
          setSearchQuery(_ => ({
            ..._,
            // searchText: filters,
            ...filters,
          }));
        }}
        tableHeading={
          <>
            <div className="arrow">
              <FaArrowLeft size={16} onClick={() => navigate(-1)} style={{ cursor: 'pointer' }} />{' '}
              {users_data?.storeData?.title} Users
            </div>
          </>
        }
        currentPage={searchQuery.page}
        pageSize={searchQuery.itemsPerPage}
        setSearchText={setSearchQuery}
        totalCount={totalCount}
        btnWidth="40px"
        placeholder="Search Users"
        content={
          <Select
            placeholder="All"
            width="140px"
            noMargin
            options={FilterOptions}
            onChange={e =>
              setSearchQuery(prev => ({
                ...prev,
                filterStatus: e?.target?.value?.value,
              }))
            }
          />
        }
        btnText={
          hasPermission('user.create-user') && (
            <ModalContainer
              width="669"
              title="Add New User"
              btnComponent={({ onClick }) => (
                <Button rounded width="141px" onClick={onClick}>
                  + Add User
                </Button>
              )}
              content={({ onClose }) => (
                <AddUserModal onClose={onClose} onSubmit={handleUserSuccessModal} data={users_data} />
              )}
            />
          )
        }>
        <Table rowsData={product_rows} columnNames={columnNamess} noPadding loading={users_loading} />
      </TableLayout>
    </ActionsWrapper>
  );
};

export default Users;
